var parent = require('../../es/instance/filter');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/filter.js
// module id = 469
// module chunks = 0 1